/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import { useForm } from 'react-hook-form'
import { Typography } from '@mui/material'
import Footer from './Footer'
import { fetchListingLoginsSettings, updateListingLoginsSettings } from '../../../../../redux/actions'
import { selectListingSettings } from '../../../../../redux/selectors'
import { MUIFormCheckboxInput } from '../../../../@Common/Form/CheckboxInput/FormCheckboxInput'

function Processing() {
  return (
    <div
      style={{
        position: 'absolute',
        top: '0px',
        right: '-30px',
        bottom: '0px',
        left: '-30px',
        minHeight: '344px',
        backgroundColor: 'rgba(255,255,255,.8)',
        overflow: 'hidden',
        zIndex: '100',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </div>
  )
}

export function LoginsSection({ listing }) {
  const dispatch = useDispatch()
  const [processing, setProcessing] = useState(true)

  const loginSettings = useSelector(selectListingSettings(listing.id, 'logins'))

  const getListingLoginsSettings = () => {
    dispatch(fetchListingLoginsSettings(listing.id))
      .then(() => setProcessing(false))
  }

  useEffect(() => {
    getListingLoginsSettings()
  }, [])

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      facebookLogin: loginSettings?.facebookLogin,
    },
  })

  useEffect(() => {
    reset({
      facebookLogin: loginSettings?.facebookLogin,
    })
  }, [loginSettings])

  const onSubmit = (values) => {
    dispatch(updateListingLoginsSettings(listing.id, { facebookLogin: !!values.facebookLogin }))
  }

  return (
    <div style={{ position: 'relative' }}>
      {
    processing
      ? <Processing />
      : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <Typography variant="h2" style={{ margin: '0px', padding: '15px 0px', fontSize: '20px' }}>Logins</Typography>
            <Typography style={{ marginBottom: '0px' }}>Allow users to register or log in using Facebook Login?</Typography>
            <div style={{ margin: '0px 0px 20px' }}>
              <MUIFormCheckboxInput
                control={control}
                name="facebookLogin"
                label="Facebook Login"
              />
            </div>
          </div>
          <Footer label="Save" processing={processing} onSubmit={handleSubmit(onSubmit)} />
        </form>
      )
}
    </div>
  )
}

export default LoginsSection
